import { Button } from '@creditornot/cb-button';
import { Modal } from '@creditornot/cbt-modal';
import { ModalFooter } from 'common/components/cookbook/Modals/ModalFooter';
import { ModalHeader } from 'common/components/cookbook/Modals/ModalHeader';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { AxiosDelistingRecommendationsError } from 'common/types';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  onDownload: () => void;
  isDownloading: boolean;
  description: string;
  error?: AxiosDelistingRecommendationsError | null;
  canDownload?: boolean;
};

export const ApproveRecommendationModal = ({
  isOpen,
  onDismiss,
  onDownload,
  isDownloading,
  description,
  error,
  canDownload = true,
}: Props) => {
  const f = useFormatMessage();

  const handleDismiss = () => {
    onDismiss();
  };

  return (
    <Modal
      open={isOpen}
      onDismiss={handleDismiss}
      sizePreset="centered:medium"
      title={f('selection_recommendations.approve_recommendation')}
      HeaderComponent={({ onCloseClick, ...rest }) => (
        <ModalHeader onDismiss={onCloseClick} {...rest}>
          {f('selection_recommendations.approve_recommendation')}
        </ModalHeader>
      )}
      footer={
        <>
          <Button variant="inverse" size="small" onClick={handleDismiss}>
            {f('common.cancel')}
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onDownload}
            loading={isDownloading}
            data-test-id="download-approved-button"
          >
            {canDownload
              ? f('selection_recommendations.approve_and_download_csv')
              : f('selection_recommendations.approve')}
          </Button>
        </>
      }
      FooterComponent={(props) => <ModalFooter error={error} {...props} />}
    >
      <div>{description}</div>
    </Modal>
  );
};
